// extracted by mini-css-extract-plugin
export var content = "_by-3";
export var list = "_by-4";
export var settingsContent = "_by-7";
export var settingsPanel = "_by-8";
export var state = "_by-6";
export var triggerBadge = "_by-2";
export var triggerButton = "_by-1";
export var triggerShell = "_by-0";
export var unreadDot = "_by-5";